import { SagaIterator } from "redux-saga";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { BulkBeneficiaryFileCheckerRemarkSaga, BulkBeneficiaryFileMakerRemarkSaga, bulkBeneficiaryFileType, BulkBeneficiaryFileVersionSaga, downloadBulkBeneficiaryFileSaga, fetchBulkBeneficiaryFileDetailSaga, fetchBulkBeneficiaryFileSaga, uploadBulkBeneficiaryFileSaga } from "./types";
import { uploadBulkBeneficiaryFileApi, fetchBulkBeneficiaryFileApi, downloadBulkBeneficiaryFileApi, fetchBulkBeneficiaryFileDetailApi, fetchBulkBeneficiaryFileVersionApi, bulkBeneficiaryFilePublishApi, approveBulkBeneficiaryFileApi, rejectBulkBeneficiaryFileApi, fetchBulkFileSpecificBeneficiaryApi, deleteBulkBeneficiaryFileApi } from "./api";

function* uploadBulkBeneficiaryFile({ payload, type }: uploadBulkBeneficiaryFileSaga): SagaIterator {
    try {
        const response = yield call(uploadBulkBeneficiaryFileApi, payload);

        yield put({
            type: bulkBeneficiaryFileType.UPLOAD_BULK_BENEFICIARY_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkBeneficiaryFileType.UPLOAD_BULK_BENEFICIARY_FILE_ERROR,
            payload: { error: error }
        });
    }
}

function* fetchBulkBeneficiaryFile({ payload, type }: fetchBulkBeneficiaryFileSaga): SagaIterator {
    try {
        const response = yield call(fetchBulkBeneficiaryFileApi, payload);

        yield put({
            type: bulkBeneficiaryFileType.FETCH_BULK_BENEFICIARY_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkBeneficiaryFileType.FETCH_BULK_BENEFICIARY_FILE_ERROR,
            payload: { error: error }
        });
    }
}


function* DownloadBulkBeneficiaryFile({ payload, type }: downloadBulkBeneficiaryFileSaga): SagaIterator {
    try {
        const response = yield call(downloadBulkBeneficiaryFileApi, payload);
        const fileURL = payload.downloadURL.split("/")
        const responseData = {
            fileBlob: response.data,
            fileName: fileURL[fileURL.length - 1]
        }
        yield put({
            type: bulkBeneficiaryFileType.BULK_BENEFICIARY_FILE_DOWNLOAD_SUCCESS,
            payload: { data: responseData }
        });
    } catch (error: any) {
        yield put({
            type: bulkBeneficiaryFileType.BULK_BENEFICIARY_FILE_DOWNLOAD_ERROR,
            payload: { error: error }
        });
    }
}

function* fetchBulkBeneficiaryFileDetail({ payload, type }: fetchBulkBeneficiaryFileDetailSaga): SagaIterator {
    try {
        const response = yield call(fetchBulkBeneficiaryFileDetailApi, payload);
        yield put({
            type: bulkBeneficiaryFileType.FETCH_BULK_BENEFICIARY_FILE_DETAIL_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkBeneficiaryFileType.FETCH_BULK_BENEFICIARY_FILE_DETAIL_ERROR,
            payload: { error: error }
        });
    }
}

function* fetchBulkBeneficiaryFileVersion({ payload, type }: BulkBeneficiaryFileVersionSaga): SagaIterator {
    try {
        const response = yield call(fetchBulkBeneficiaryFileVersionApi, payload);
        yield put({
            type: bulkBeneficiaryFileType.BULK_BENEFICIARY_FILE_VERSION_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkBeneficiaryFileType.BULK_BENEFICIARY_FILE_VERSION_ERROR,
            payload: { error: error }
        });
    }
}

function* publishBulkBeneficiaryFile({ payload, type }: BulkBeneficiaryFileMakerRemarkSaga): SagaIterator {
    try {
        const response = yield call(bulkBeneficiaryFilePublishApi, payload);
        yield put({
            type: bulkBeneficiaryFileType.PUBLISH_BULK_BENEFICIARY_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkBeneficiaryFileType.PUBLISH_BULK_BENEFICIARY_FILE_ERROR,
            payload: { error: error }
        });
    }
}

function* approveBulkBeneficiaryFile({ payload, type }: BulkBeneficiaryFileCheckerRemarkSaga): SagaIterator {
    try {
        const response = yield call(approveBulkBeneficiaryFileApi, payload);
        yield put({
            type: bulkBeneficiaryFileType.APPROVE_BULK_BENEFICIARY_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkBeneficiaryFileType.APPROVE_BULK_BENEFICIARY_FILE_ERROR,
            payload: { error: error }
        });
    }
}

function* rejectBulkBeneficiaryFile({ payload, type }: BulkBeneficiaryFileCheckerRemarkSaga): SagaIterator {
    try {
        const response = yield call(rejectBulkBeneficiaryFileApi, payload);
        yield put({
            type: bulkBeneficiaryFileType.REJECT_BULK_BENEFICIARY_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkBeneficiaryFileType.REJECT_BULK_BENEFICIARY_FILE_ERROR,
            payload: { error: error }
        });
    }
}

function* fetchBulkFileSpecificBeneficiary({ payload, type }: BulkBeneficiaryFileVersionSaga): SagaIterator {
    try {
        const response = yield call(fetchBulkFileSpecificBeneficiaryApi, payload);
        yield put({
            type: bulkBeneficiaryFileType.FETCH_BULK_FILE_SPECIFIC_BENEFICIARY_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkBeneficiaryFileType.FETCH_BULK_FILE_SPECIFIC_BENEFICIARY_ERROR,
            payload: { error: error }
        });
    }
}

function* deleteBulkBeneficiaryFile({ payload, type }: fetchBulkBeneficiaryFileDetailSaga): SagaIterator {
    try {
        const response = yield call(deleteBulkBeneficiaryFileApi, payload);
        yield put({
            type: bulkBeneficiaryFileType.DELETE_BULK_BENEFICIARY_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkBeneficiaryFileType.DELETE_BULK_BENEFICIARY_FILE_ERROR,
            payload: { error: error }
        });
    }
}

export function* watchUploadBulkBeneficiaryFile() {
    yield takeEvery(bulkBeneficiaryFileType.UPLOAD_BULK_BENEFICIARY_FILE, uploadBulkBeneficiaryFile);
}

export function* watchFetchBulkBeneficiaryFile() {
    yield takeEvery(bulkBeneficiaryFileType.FETCH_BULK_BENEFICIARY_FILE, fetchBulkBeneficiaryFile);
}


export function* watchDownloadBulkBeneficiaryFile() {
    yield takeEvery(bulkBeneficiaryFileType.BULK_BENEFICIARY_FILE_DOWNLOAD, DownloadBulkBeneficiaryFile);
}

export function* watchFetchBulkBeneficiaryFileDetail() {
    yield takeEvery(bulkBeneficiaryFileType.FETCH_BULK_BENEFICIARY_FILE_DETAIL, fetchBulkBeneficiaryFileDetail);
}

export function* watchBulkBeneficiaryFileVersion() {
    yield takeEvery(bulkBeneficiaryFileType.BULK_BENEFICIARY_FILE_VERSION, fetchBulkBeneficiaryFileVersion);
}

export function* watchPublishBulkBeneficiaryFile() {
    yield takeEvery(bulkBeneficiaryFileType.PUBLISH_BULK_BENEFICIARY_FILE, publishBulkBeneficiaryFile);
}

export function* watchApproveBulkBeneficiaryFile() {
    yield takeEvery(bulkBeneficiaryFileType.APPROVE_BULK_BENEFICIARY_FILE, approveBulkBeneficiaryFile);
}

export function* watchRejectBulkBeneficiaryFile() {
    yield takeEvery(bulkBeneficiaryFileType.REJECT_BULK_BENEFICIARY_FILE, rejectBulkBeneficiaryFile);
}

export function* watchFetchBulkFileSpecificBeneficiary() {
    yield takeEvery(bulkBeneficiaryFileType.FETCH_BULK_FILE_SPECIFIC_BENEFICIARY, fetchBulkFileSpecificBeneficiary);
}


export function* watchDeleteBulkBeneficiaryFile() {
    yield takeEvery(bulkBeneficiaryFileType.DELETE_BULK_BENEFICIARY_FILE, deleteBulkBeneficiaryFile);
}

function* BulkBeneficiaryFileSaga() {
    yield all([
        fork(watchUploadBulkBeneficiaryFile),
        fork(watchFetchBulkBeneficiaryFile),
        fork(watchDownloadBulkBeneficiaryFile),
        fork(watchFetchBulkBeneficiaryFileDetail),
        fork(watchBulkBeneficiaryFileVersion),
        fork(watchPublishBulkBeneficiaryFile),
        fork(watchApproveBulkBeneficiaryFile),
        fork(watchRejectBulkBeneficiaryFile),
        fork(watchFetchBulkFileSpecificBeneficiary),
        fork(watchDeleteBulkBeneficiaryFile)
    ]);
}

export default BulkBeneficiaryFileSaga;